import { render, staticRenderFns } from "./WorkFlowComponent.vue?vue&type=template&id=fe209a40"
import script from "./WorkFlowComponent.vue?vue&type=script&lang=ts"
export * from "./WorkFlowComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports